import { V3Record } from 'data/helpers/V3Record.js'

export const RegionItem = V3Record('region_item', {
  name: null
})
